
import toast from "react-hot-toast";

export const SuccessMessage = (message) => {
  toast.success(message, {
    duration: 3000,
  });
};

export const ErrorMessage = (message) => {
  toast.error(message, {
    duration: 4000,
  });
};

export const showLoading = (message = "Loading...") => {
  return toast.loading(message);
};

export const dismissToast = (toastId) => {
  toast.dismiss(toastId);
};




const removeAuth = () =>{
    localStorage.removeItem('userData')
    localStorage.removeItem('accessToken');
    
  }

const Apiloader = ({ type }) => {
  return (
    <div className="loading-wrapper">
      <div className="spinner"></div>
      <p className="text-white mt-3">Loading {type}...</p>
    </div>
  );
};

export { removeAuth,Apiloader };
